import React, { useCallback } from 'react'
import { I18n } from 'react-redux-i18n'
import _cloneDeep from 'lodash.clonedeep'

import IntegrationAppAPI from 'api/integrationApp'
import SaveToastNotification from 'utils/toasts/SaveToastNotification'
import BasicTable from 'components/tables/BasicTable'
import useScopes from './useScopes'
import ScopeHeader from './ScopeHeader'
import ActivityAPIForm from './ActivityAPIForm'

/**
 * Activity API
 * @param {object} props
 * @param {object} props.app
 * @param {function} props.setApp
 *
 * @returns {React.Component}
 */
const ActivityAPI = (props) => {
  const { app, setApp } = props

  const [scopes, setScopes, loading] = useScopes({
    app, key: 'activityApi', name: 'activity_api'
  })

  const onActive = useCallback(
    async (item, scopes) => {
      try {
        const scopesCopy = _cloneDeep(scopes)

        const idx = scopesCopy.findIndex(elem => elem._id === item._id)
        scopesCopy[idx].isActive = !item.isActive

        setScopes(scopesCopy)

        const updatedApp = await IntegrationAppAPI.updateById({
          identifier: app._id,
          activityApi: {
            scopes: scopesCopy.filter(elem => elem.isActive)
              .map(elem => elem.name)
          }
        })

        setApp(updatedApp)

        SaveToastNotification.ok()
      } catch (error) {
        setScopes(_cloneDeep(scopes))

        SaveToastNotification.error()
      }
    }, []
  )

  return (
    <>
      <ScopeHeader
        app={app}
        setApp={setApp}
        type='activityApi'
        title={I18n.t('integration_app_scope_activity_title')}
        description={I18n.t('integration_app_activity_info')}
      />

      <ActivityAPIForm
        app={app}
        setApp={setApp}
      />

      <BasicTable
        isLoading={loading}
        className='scopes-activity-table'
        notResultText={I18n.t('integration_app_scopes_not_results')}
        rows={scopes}
        headRows={[{
          label: I18n.t('integration_app_scope_cell_subscribed'),
          className: 'scope__cell-subscribed',
          field: 'isActive',
          filedType: 'toggle',
          onToggle: (item) => onActive(item, scopes)
        }, {
          label: I18n.t('integration_app_scope_cell_name'),
          field: 'name',
          title: true,
          className: 'scope__cell-name'
        }, {
          label: I18n.t('integration_app_scope_cell_description'),
          field: 'description',
          className: 'scope__cell-description',
          bodyNotEllipsis: true
        }]}
      />
    </>
  )
}

export default ActivityAPI
